import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import { postSecureAccountsApi, deleteAccountsApi, getSecureAccountsApi } from "@Shared/utils/ajax";
export const getNotifications = async (filters, pagination) => {
  const {
    offset = 0,
    limit = 0
  } = pagination || {};
  return getSecureAccountsApi(_objectSpread(_objectSpread({}, filters), {}, {
    offset,
    limit
  }), "/notification");
};
export const getRegisteredDevices = async () => {
  return getSecureAccountsApi({}, "/notification/device");
};
export const registerDevice = async payload => {
  return postSecureAccountsApi(payload, "/notification/device");
};
export const updateDeviceLastSeen = async (id, deviceToken) => {
  return postSecureAccountsApi({
    deviceToken
  }, `/notification/device/${id}`);
};
export const unregisterDevice = async id => {
  return deleteAccountsApi(`/notification/device/${id}`);
};
export const markAsRead = async (origin, id) => {
  return postSecureAccountsApi({}, `/notification/${origin}/${id}`);
};